import React from 'react';
import { useParams } from 'react-router-dom';
import { normalizeTemuShopTypeSlug } from '@/temu-platform/constants/temuRoutes';
import ReturnOrderListPage from '@/temu-platform/modules/aftersales/ReturnOrderListPage';
import SemiReturnOrderListPage from '@/temu-platform/modules/aftersales/SemiReturnOrderListPage';

/** 全托退供包裹 vs 半托/本土销售售后，同 URL 分流 */
export default function TemuReturnsRoutePage() {
  const { shopType } = useParams();
  const slug = normalizeTemuShopTypeSlug(shopType) || 'semi';
  if (slug === 'full') {
    return <ReturnOrderListPage />;
  }
  return <SemiReturnOrderListPage />;
}
